module.exports = __webpack_public_path__ + "img/uploadfile.591807ad.svg";